import { PHR_TABLE_LABELS, type PhrTableKey } from '@/entities/user-phr';
import { PhrTableTab } from '@/features/phr-table';
import { WarningBanner, WorkspaceSection } from '@/shared/ui/primitives';

import { DiagnosedConditionsTable } from './DiagnosedConditionsTable';

const HEALTH_RECORDS_TABLE_KEYS = [
  'conditions',
  'medications',
  'notes',
  'procedures',
  'vitals',
] as const satisfies readonly PhrTableKey[];

export interface PatientHealthRecordsTabProps {
  userId: string;
}

export function PatientHealthRecordsTab({ userId }: PatientHealthRecordsTabProps) {
  return (
    <div className="space-y-6" aria-label="Health Records">
      <WorkspaceSection title="Lotus Diagnosed Conditions">
        <DiagnosedConditionsTable />
      </WorkspaceSection>

      <WarningBanner tone="orange">
        Imported EHR data can be inaccurate or out of date. Verify in the source system before
        acting.
      </WarningBanner>

      {HEALTH_RECORDS_TABLE_KEYS.map((key) => (
        <WorkspaceSection key={key} title={PHR_TABLE_LABELS[key]}>
          <PhrTableTab userId={userId} tableKey={key} />
        </WorkspaceSection>
      ))}
    </div>
  );
}
